const styles = {
    buttonStyle: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        width: '100%'
    },
    calendarContentContainer: {
        display:'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    calendarNav: {
        display: 'flex',
        flex: 1,
        height: 70,
        justifyContent: 'space-between',
    },
    container: {
        WebkitTransition: 'all 1s',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '0 auto',
        marginBottom: 30,
        maxWidth: 1200,
        paddingLeft: 10,
        paddingRight: 10,
    },
    dateText: {
        color: 'rgba(0,0,0,1)',
        fontSize: 14,
        paddingBottom: 1,
        paddingTop: 5,
        textAlign: 'center',
    },
    dateTitleDivider: {
        alignSelf: 'center',
        borderBottom: '1px solid red',
        height: 4,
        textAlign: 'center',
        width: '40%',
    },
    dayContainer: {
        alignItems: 'center',
        display: 'flex',
        flex: '1 1 14%', 
        flexDirection: 'column',
        minWidth: 50,
        padding: 10,
        paddingLeft: 5,
        paddingRight: 5,
    },
    dayHeader: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: 70,
    },
    dayText: {
        color: 'rgba(0,0,0,1)',
        fontSize: 14,
        paddingBottom: 5,
        paddingTop: 5,
        textAlign: 'center',
    },
    navButtons: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        borderWidth: 0,
        display: 'flex',
        fontSize: 15,
        justifyContent: 'space-between',
        marginBottom: -15,
        padding: '15px 20px',
        position: 'relative',
        width: 100,
        zIndex: 5,
    },
    outerContainer: {
        height: '100%',
        justifyContent: 'center',
        margin: '0 auto',
        minWidth: '100vw',
        overflowX: 'scroll',
    },
    slotStyle: {
        backgroundColor: 'rgba(0,0,0,0.1)',
        borderRadius: 5,
        display: 'flex',
        height: 40,
        justifyContent: 'center',
        marginBottom: 5,
        marginTop: 5,
        textAlign: 'center',
        width: '100%',
    },
}

export { styles as calendarStyles };


// WEBPACK FOOTER //
// ./src/js/components/Calendar/styles.ts